import { CheckCircle2, Circle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function SetupProgress({ o }) {
  const s = o.setup;
  if (!s) return null;
  const full = s.done === s.total;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className={`text-xs px-2 py-0.5 rounded border tabular-nums ${full ? "bg-emerald-50 text-emerald-800 border-emerald-200" : "bg-amber-50 text-amber-800 border-amber-200"}`} data-testid={`org-setup-${o.id}`}>
          {full ? "Ready" : `${s.done}/${s.total} done`}</button>
      </PopoverTrigger>
      <PopoverContent className="w-72 text-sm" data-testid={`org-setup-list-${o.id}`}>
        <p className="font-semibold mb-2">Setup checklist</p>
        <ul className="space-y-1.5">{s.items.map((i) => (
          <li key={i.key} className="flex items-center gap-2" data-testid={`org-setup-${o.id}-${i.key}`}>
            {i.done ? <CheckCircle2 className="w-4 h-4 text-emerald-600 shrink-0" /> : <Circle className="w-4 h-4 text-slate-300 shrink-0" />}<span className={i.done ? "" : "text-slate-600"}>{i.label}</span></li>))}</ul>
      </PopoverContent>
    </Popover>
  );
}
